// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chat-cont-right[data-v-2eece8a8]{width:70%;padding:20px}.chat-body[data-v-2eece8a8]{background:#fff;border-radius:8px;padding:20px;box-shadow:0 0 10px rgba(0,0,0,.1);height:400px;overflow-y:auto}@media (max-width:768px){.chat-cont-right[data-v-2eece8a8]{width:100%;padding:10px}.chat-body[data-v-2eece8a8]{height:auto}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
